const map = {
	"./drafts.svg": 60054,
	"./email-broadcasts-dex.svg": 24969,
	"./email-broadcasts.svg": 93815,
	"./success-sent.svg": 79435,
	"./text-only-broadcast-dex.svg": 9224,
	"./text-only-broadcast.svg": 15920
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94029;